import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getTokenData } from '../services/api';
import axios from '../utils/axios';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

const LoaderSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 111, 0, 0.15);
  border-top-color: #ff6f00;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const withTicketProtection = (WrappedComponent) => {
  return function WithTicketProtectionComponent(props) {
    const navigate = useNavigate();
    const { lang, ticketId } = useParams();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const checkAccess = async () => {
        try {
          const tokenData = getTokenData();
          
          if (!tokenData) {
            navigate(`/${lang}`, { replace: true });
            return;
          }

          // Перевіряємо, чи користувач є адміністратором або модератором
          if (tokenData.roleId === 3 || tokenData.roleId === 4) {
            setIsAuthorized(true);
            setLoading(false);
            return;
          }

          // Якщо користувач не адмін/модератор, перевіряємо чи це його тікет
          const response = await axios.get(`/api/support/tickets/${ticketId}`);
          
          if (response.data.success && response.data.ticket.userId === tokenData.userId) {
            setIsAuthorized(true);
          } else {
            navigate(`/${lang}/support`, { replace: true });
          }
        } catch (error) {
          console.error('Error checking ticket access:', error);
          navigate(`/${lang}/support`, { replace: true });
        } finally {
          setLoading(false);
        }
      };

      checkAccess();
    }, [navigate, ticketId, lang]);

    if (loading) {
      return (
        <LoaderContainer>
          <LoaderSpinner />
        </LoaderContainer>
      );
    }

    return isAuthorized ? <WrappedComponent {...props} /> : null;
  };
};

export default withTicketProtection; 